import React,{useState,useEffect} from 'react'
import { VerifyEmailStyle } from './VerifyEmail.styled'
import Footer from '../../components/footer/Footer'
import TopBar2 from '../../components/TopBar/TopBar2'
import { useParams } from 'react-router-dom'
import { checkEmail } from '../../api/EmailApi'
import { useQuery } from '@tanstack/react-query'
import { HeadingStyles2 } from '../../styles/HeadingStyles'

const VerifiedComponent=({verified})=>{
  return <div className='body'>
      {verified===1 && 
        <>
          <HeadingStyles2>Ocufii Two-Step Verification</HeadingStyles2>
          <img src={`${process.env.PUBLIC_URL}/acceptIcon.png`} alt="Logo" className='imgLogo'  />
          <p className='smsTxt'>Verified!</p>
          {/* <p className='smsTxt'>You have successfully </p> */}
        </> 
      }
      {verified===2 && 
        <>
          <HeadingStyles2>Ocufii Two-Step Verification</HeadingStyles2>
          <img src={`${process.env.PUBLIC_URL}/rejectIcon.png`} alt="Logo" className='imgLogo' />
          <p className='smsTxt'>Verify Forgot Password Link Expired!</p>
          {/* <p className='smsTxt'>It look like the delete beacon link has expired.</p> */}
        </>
      }
      {verified===3 && 
        <>
          <HeadingStyles2>Ocufii Two-Step Verification</HeadingStyles2>
          <img src={`${process.env.PUBLIC_URL}/rejectIcon.png`} alt="Logo" className='imgLogo' />
          <p className='smsTxt'>Link Expired!</p>
          <p className='smsTxt'>It look like the Forgot Password link has expired.</p>
          <p className='smsTxt2'>Having repeated issues deleting beacon? Contact support</p>
        </>
      }
  </div> 
}
const VerifyForgotPassword = () => {
  const [loading, setLoading] = useState(true)
  const [verified, setVerified] = useState(3)
  const {email,token}=useParams()
  const [enableAPI, setEnableAPI] = useState(false)

 

  const {
    status : verifyForgotPasswordStatus,
    data: verifyForgotPasswordData,
  }=useQuery({
    queryKey:["verifyForgotPassword",token],
    queryFn:()=>checkEmail("verifyForgotPassword",email,token),
    enabled:enableAPI,
    onSuccess:(data)=>{
      if(data.status===400){
        setVerified(2)
      }else{
        setVerified(1)
      }
      setEnableAPI(false)
    },
    onError:()=>{
      setVerified(3)
    }

  })

  useEffect(() => {
    if(email || token){
      setEnableAPI(true)
    }else{
      setEnableAPI(false)
    }
  }, [email,token])
  
  

  return (
    <VerifyEmailStyle>
        <TopBar2  />
        {verifyForgotPasswordStatus==="loading"
          ?
          <div className='body'>
            <p className='description'>Loading ...</p>
          </div>
          : 
         <VerifiedComponent verified={verified}  />
        }  
        <Footer />
    </VerifyEmailStyle>
  )
}

export default VerifyForgotPassword